import VueRecaptcha from "vue-recaptcha";
import moment from "moment";
// import swal from "sweetalert";
export default {
  name: "home",
  components: {
    "vue-recaptcha": VueRecaptcha,
  },
  created() {
    window.scrollTo(0, 0);
    this.CheckLoginStatus();
    
  },
  filters: {
    moment: function (date) {
      if (date === null) {
        return "فارغ";
      }
      // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
      return moment(date).format("MMMM Do YYYY");
    },
  },
  data() {
    return {
      CounterRedirection: 0,
      ElSteps: 0,
      Percentage: 0,
      ApprovalId: 0,
      loading: false,
      code: 0,
      CertificateData: 0,
      loginDetails: null,
    };
  },
  methods: {
    CheckLoginStatus() {
      try {
        this.loginDetails = JSON.parse(
          localStorage.getItem("currentUser-client")
        );
        if (this.loginDetails == null) {
          window.location.href = "/Login";
        }
      } catch (error) {
        window.location.href = "/Login";
      }
    },
    PrintPermission(code, CertificateData) {
      this.$blockUI.Start();
      this.$http
        .GetCrtificatePDF(
          code,
          this.loginDetails.name,
          this.loginDetails.nameEng,
          CertificateData,
          this.CertificateId
        )
        .then((response) => {
          this.$blockUI.Stop();

          var blobFile = response.data;
          var fileURL = URL.createObjectURL(blobFile);
          window.open(fileURL);
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    Print(code, CertificateData) {
      this.$blockUI.Start();
      this.$http
        .GetCrtificateWPDF(
          code,
          this.loginDetails.name,
          this.loginDetails.nameEng,
          CertificateData,
          this.CertificateId
        )
        .then((response) => {
          this.$blockUI.Stop();

          var blobFile = response.data;
          var fileURL = URL.createObjectURL(blobFile);
          window.open(fileURL);
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    PrintReport() {
      this.$blockUI.Start();
      this.$http
        .Print(this.ApprovalId)
        .then((response) => {
          this.$blockUI.Stop();
          var blobFile = response.data;
          var fileURL = URL.createObjectURL(blobFile);
          window.open(fileURL);
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },

    // onSubmit: function () {
    //     this.$refs.invisibleRecaptcha.execute();
    // },
    // onVerify: function (response) {
    //     this.CaptchaVerify = response;
    //    // console.log("Verify: " + response);
    // },
    // onExpired: function () {
    //     //console.log("Expired");
    // },
    // resetRecaptcha() {
    //     this.$refs.recaptcha.reset(); // Direct call reset method
    // },
    // href(url) {
    //     this.$router.push(url);
    // },
    // submitForm(formName) {
    //     if (!this.CaptchaVerify) {
    //         this.$message({
    //             type: 'error',
    //             message: 'الـرجاء التحقق من انك لست روبوت '
    //         });
    //         return;
    //     }

    //     this.ruleForm.Recaptcha = this.CaptchaVerify;

    //     this.$refs[formName].validate((valid) => {
    //         if (valid) {
    //             this.$blockUI.Start();

    //             this.$http
    //                 .AddCitizens(this.ruleForm)
    //                 .then((response) => {
    //                     this.$blockUI.Stop();
    //                     swal({
    //                         title: "نجـاح العملية",
    //                         text:
    //                             "تم تسجيل بياناتك الأولية بنجاح وسيتم ارسال رمز التحقق الي هاتفك بعد التحقق من الهوية",
    //                         icon: "success",
    //                         button: "Ok",
    //                     }).then(() => {
    //                         //open sessions
    //                         localStorage.setItem(
    //                             "UserInfo",
    //                             JSON.stringify(response.data)
    //                         );
    //                         this.href('/IdintityConfirmation', 1);
    //                     });
    //                     this.$refs[formName].resetFields();
    //                 })
    //                 .catch((error) => {
    //                     this.resetRecaptcha();
    //                     this.CaptchaVerify = "";
    //                     this.$blockUI.Stop();
    //                    // console.log(error.response.status);
    //                     if (error.response.status === 400) {
    //                         this.$alert(
    //                             "<h4>" + error.response.data + "</h4>",
    //                             "",
    //                             this.warning
    //                         );
    //                     }
    //                     if (error.response.status === 404) {
    //                         this.$alert(
    //                             "<h4>" + error.response.data + "</h4>",
    //                             "",
    //                             this.error
    //                         );
    //                     } else {
    //                         this.$alert(
    //                             "<h4>" + error.response.data + "</h4>",
    //                             "",
    //                             this.error
    //                         );
    //                     }
    //                 });
    //         } else {
    //             //console.log("error submit!!");
    //             return false;
    //         }
    //     });
    // },

    // resetForm(formName) {
    //     this.$refs[formName].resetFields();
    // },
  },
};
